const SPECIALIZATION_COMPONENTS = {
};

export default SPECIALIZATION_COMPONENTS;
